import {
  ApiGetRequest,
  ApiPostRequest,
  //   ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Order Jual',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Order Jual',
        href: '/adm/logistic/order-jual/order-pemjualan',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_order_jual',
    sortDesc: true,
    fields: [
      {
        key: 'code_order_jual',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'tgl_jual',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_sale',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'total_invoice',
        label: 'Total',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
      {
        key: 'status_order_jual',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'code_order_jual',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'tgl_jual',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_sale',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
    ],
    journal: false,
    row_item: {
      description: '',
      id_product: '',
      item_acc: '',
      item_order: '',
      item_send: '',
      id_satuan: '',
      item_price: '',
      item_disc: '',
      item_disc_nominal: '',
      item_acc_disc: '',
      item_id_pajak: '',
      item_acc_tax: '',
      item_tax: '',
      item_persentase: 0,
      item_total: 0,
    },
    form: {
      code_jual: '',
      id_principle: '',
      principle_code: '',
      principle_name: '',
      tgl_jual: '',
      tgl_faktur: '',
      tgl_kirim: '',
      id_currency: '',
      id_department: '',
      id_gudang: '',
      type_sale: false,
      type_payment: false,
      remark: '',
      term_payment: '',
      memo: '',
      other_cost: '',
      acc_other_cost: '',
      acc_other_cost_code: '',
      acc_other_cost_name: '',
      total_pajak: '',
      total_invoice: '',
      down_payment: '',
      id_um_jual: '',
      total_payment: '',
      acc_total_payment: '',
      acc_total_payment_code: '',
      acc_total_payment_name: '',
      status_jual: '',
      id_journal: '',
      id_sales: '',
      sales_code: '',
      sales_name: '',
      items: [
        {
          description: '',
          id_product: '',
          item_acc: '',
          item_order: '',
          item_send: '',
          id_satuan: '',
          item_price: '',
          item_disc: '',
          item_disc_nominal: '',
          item_acc_disc: '',
          item_id_pajak: '',
          item_acc_tax: '',
          item_tax: '',
          item_persentase: 0,
          item_total: 0,
        },
      ],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeOrderJual(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetForm(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        code_jual: '',
        id_principle: '',
        principle_code: '',
        principle_name: '',
        tgl_jual: '',
        tgl_faktur: '',
        tgl_kirim: '',
        id_currency: '',
        id_department: '',
        id_gudang: '',
        type_sale: false,
        type_payment: false,
        remark: '',
        term_payment: '',
        memo: '',
        other_cost: '',
        acc_other_cost: '',
        acc_other_cost_code: '',
        acc_other_cost_name: '',
        total_pajak: '',
        total_invoice: '',
        down_payment: '',
        id_um_jual: '',
        total_payment: '',
        acc_total_payment: '',
        acc_total_payment_code: '',
        acc_total_payment_name: '',
        status_jual: '',
        id_journal: '',
        id_sales: '',
        sales_code: '',
        sales_name: '',
        items: [
          {
            description: '',
            id_product: '',
            item_acc: '',
            item_order: '',
            item_send: '',
            id_satuan: '',
            item_price: '',
            item_disc: '',
            item_disc_nominal: '',
            item_acc_disc: '',
            item_id_pajak: '',
            item_acc_tax: '',
            item_tax: '',
            item_persentase: 0,
            item_total: 0,
          },
        ],
      },
    });
  },
};

export const actions = {
  async getLastNoFaktur({ commit, state }) {
    commit('changeOrderJual', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/order-jual/last-id`);
    commit('changeOrderJual', {
      form: {
        ...data.form,
        code_jual: result.data.object,
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListOrderJual({ commit, state }) {
    commit('changeOrderJual', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      for_invoice: data.for_invoice ? 1 : 0,
    };

    let result = await ApiGetRequest(`logistic/order-jual`, params);
    commit('changeOrderJual', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getJournalInvoice({ commit }, payload = null) {
    commit('changeOrderJual', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `logistic/order-jual/${payload.id}/journal`
    );
    commit('changeOrderJual', {
      loading: false,
    });

    if (!result.error) {
      commit('changeOrderJual', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getDetailOrderJual({ commit, state }, payload = null) {
    commit('changeOrderJual', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/order-jual/${payload.id}`);
    commit('changeOrderJual', {
      loading: false,
    });

    if (!result.error) {
      commit('changeOrderJual', {
        detail: result.data.object,
        form: {
          ...data.form,
          ...result.data.object,
          tgl_faktur: result.data.object.tgl_faktur
            ? moment(result.data.object.tgl_faktur).format('DD/MM/YYYY')
            : '',
          type_sale:
            result.data.object.type_sale &&
            parseInt(result.data.object.type_sale) > 0
              ? 1
              : 0,
          type_payment:
            result.data.object.type_payment &&
            parseInt(result.data.object.type_payment) > 0
              ? 1
              : 0,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createOrderJual({ commit, state, dispatch }) {
    commit('changeOrderJual', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('logistic/order-jual', data.form);

    commit('changeOrderJual', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateOrderJual({ commit, state, dispatch }, payload = null) {
    commit('changeOrderJual', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `logistic/order-jual/${payload.id}`,
      data.form
    );

    commit('changeOrderJual', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
